import React from 'react';
import styled from 'styled-components';

import InputCounter from 'partials/InputCounter';

import Media from 'css/Media';
import WP from 'WP';

const GuestGroup = (props) => {

    return (
        <GuestPopUp open={ props.open } id={props.id}>
            <StyledLabel>
                <span>{WP.trans.amountOfRooms}:</span>
                <InputCounter 
                    name='numRooms'
                    handleChange={(name,value) => props.handleChange(name,value)}
                    value={props.numRooms || 0}
                />
            </StyledLabel>
            <StyledLabel>
                <span>{WP.trans.amountOfGuests}:</span>
                <InputCounter 
                    name='numPersons'
                    handleChange={(name,value) => props.handleChange(name,value)}
                    value={props.numPersons || 0}
                />
            </StyledLabel>
        </GuestPopUp>
    )
}

export default GuestGroup;

const GuestPopUp = styled.div`
    display: none;
    width: 100%;
    top: ${props => props.theme.spacing.elementM};

    ${Media.greaterThan('s')`
        min-width: 390px;
        width: 100%;
        display: inline-block;  
        background: white;
        z-index: 1000;
        position: absolute;
        padding: ${props => props.theme.spacing.contentXL};
        left: 0;
        border: 1px solid ${props => props.theme.colors.text};
        border-radius: 20px;
        -webkit-animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);
        animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);
        input[type=number] {
          -moz-appearance: textfield;
        }
        @-webkit-keyframes fpFadeInDown {
            from {
                opacity: 0;
                -webkit-transform: translate3d(0, -20px, 0);
                        transform: translate3d(0, -20px, 0);
            }
            to {
                opacity: 1;
                -webkit-transform: translate3d(0, 0, 0);
                        transform: translate3d(0, 0, 0);
            }
            }
            @keyframes fpFadeInDown {
            from {
                opacity: 0;
                -webkit-transform: translate3d(0, -20px, 0);
                        transform: translate3d(0, -20px, 0);
            }
            to {
                opacity: 1;
                -webkit-transform: translate3d(0, 0, 0);
                        transform: translate3d(0, 0, 0);
            }
        }
    `}
`

const StyledLabel = styled.label`
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    margin-bottom: ${props => props.theme.spacing.contentM};

    >span {
        white-space: nowrap;
        width: 50%;
        ${props => props.theme.fonts.p}

        ${Media.greaterThan('s')`
            font-size: 16px;
            line-height: 19px;
        `}
    }

    >div {
        width: 40%;
    }
`